import { useEffect, useState } from "react";


interface QuickLinkProps {
    subscriber: number;
    names: string[],
    numbers: string[],
    floors: number[],
    rooms: string[]
}

export const useQuickLinks = () => {
    // Quick links for checkout
    const [quickLinks, setQuickLinks] = useState<QuickLinkProps[]>(() => {
        const saved = localStorage.getItem("CatermatQuickLinks");
        return saved ? JSON.parse(saved) : []
    });
    // Save to localStorage every time QuickLinks change
    useEffect(() => {
        localStorage.setItem("CatermatQuickLinks", JSON.stringify(quickLinks));
    }, [quickLinks]);

    // Clear quick links
    const clearLinks = () => {
        localStorage.removeItem("CatermatQuickLinks");
        setQuickLinks([])
    }
    return {quickLinks, setQuickLinks, clearLinks}
};